<div class="boxWhite">
  <h4>CONFIRMAR VIAJE</h4>

  <button class="btn btnClose" (click)="close()">
    <img src="assets/img/icoClose.svg" alt="">
  </button>

  <div class="headInfo bgLightGray" *ngIf="viaje">
    <div class="servicio">
      <span>SERVICIO</span>
      <h4>{{ viaje.servicio || '302C' }}</h4>
    </div>
    <div class="info">
      <div class="item">
        <span>ID VIAJE</span>
        <p>{{ viaje.viajeCodigo || '123-2-3-12' }}</p>
      </div>
      <div class="item">
        <span>INICIO</span>
        <p>{{ viaje.fechahoraInicio ? (viaje.fechahoraInicio | date:'HH:mm') : '18:55' }}</p>
      </div>
      <div class="item">
        <span>NOMBRE CB</span>
        <p>{{ viaje.conductor ? (viaje.conductor.nombres + ' ' + viaje.conductor.apellidoPaterno) : 'PEDRO AGUIRRE' }}</p>
      </div>
      <div class="item">
        <span>PATENTE</span>
        <p>{{ viaje.movil?.patente || 'BXAO93' }}</p>
      </div>
    </div>
  </div>

  <div class="headInfo bgLightGray" *ngIf="!viaje">
    <div class="servicio">
      <span>SERVICIO</span>
      <h4>302C</h4>
    </div>
    <div class="info">
      <div class="item">
        <span>ID VIAJE</span>
        <p>123-2-3-12</p>
      </div>
      <div class="item">
        <span>INICIO</span>
        <p>18:55</p>
      </div>
      <div class="item">
        <span>NOMBRE CB</span>
        <p>PEDRO AGUIRRE</p>
      </div>
      <div class="item">
        <span>PATENTE</span>
        <p>BXAO93</p>
      </div>
    </div>
  </div>

  <div class="footModal mt-3">
    <button class="btn btnGreen w-100" [disabled]="enviando" (click)="confirmarViaje()">
      <span *ngIf="enviando" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      CONFIRMAR
    </button>
    <button class="btn btnBlack w-100 mt-3" [disabled]="enviando" (click)="confirmarViaje(true)">
      <span *ngIf="enviando" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      CONFIRMAR E IMPRIMIR
    </button>
  </div>
</div>
